import { ADMIN_ROLE } from '../data/constants'

const validate_user_role = (groups) => {
  if (!groups) return false
  return groups.includes(ADMIN_ROLE)
}

export { validate_user_role }
